import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HelpCircle } from "lucide-react";
import { FaqAccordion } from "../components/FaqAccordion";
import { FAQS } from "../data/faq";

export default function Faq() {
    return (
        <div data-testid="faq-page">
            <section className="bg-primary text-primary-foreground">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
                    <p className="text-sm uppercase tracking-[0.2em] text-secondary mb-3 flex items-center gap-2"><HelpCircle size={16} /> Help Center</p>
                    <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight">Frequently Asked Questions</h1>
                    <p className="text-primary-foreground/70 mt-3 max-w-2xl">Everything wholesale buyers, stores, restaurants, and business customers need to know about ordering from YATTO LLC.</p>
                </div>
            </section>

            <section className="py-16 sm:py-24">
                <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
                    <FaqAccordion items={FAQS} />
                </div>
            </section>

            <section className="bg-foreground text-background">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 text-center">
                    <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight mb-3">Ready to stock your shelves?</h2>
                    <p className="text-background/70 mb-8">Submit your wholesale order request today.</p>
                    <div className="flex flex-wrap gap-4 justify-center">
                        <Link to="/order" className="flex items-center gap-2 bg-secondary text-secondary-foreground px-8 py-4 font-semibold hover:-translate-y-1 transition-transform">Place Order Request <ArrowRight size={18} /></Link>
                        <Link to="/contact" className="flex items-center gap-2 border border-background/30 text-background px-8 py-4 font-semibold hover:bg-background hover:text-foreground transition-colors">Contact Us</Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
